import React from 'react';
import { InlineWidget } from "react-calendly";

function Connect() {
  const topics =[
    // "Startups & AI – My journey with Insio and AI in insurance",
    "Insurance & Investing – Smarter property decisions with data",
    "Tech & Data Science – Python, SQL, cloud, and analytics",
    "Career & Growth – Breaking into data, tech, and entrepreneurship",
    "Networking & Collaboration – Let’s explore opportunities together"
  ]

  return (
    <div className="app">
      {/* <div className="container"> */}
        <main className="main-contents">

          {/* Schedule Coffee Chat Section */}
          <section className='features'>
            <h2 className="section-title">Let's Connect!</h2>
            <ul className="contents-list">
              {topics.map((item, index) => (
                <li key={index} className="feature-item">
                  <span className="bullet-point">•</span> {item}
                </li>
              ))}
            </ul>
            <p className='section-text'>Looking forward to chatting! 🚀</p>
            <br></br>
            <InlineWidget url="https://calendly.com/jeswang421/coffee-chat-with-jessy" />
          </section>

        </main>
      </div>
    // </div>
  );
}

export default Connect;